import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AgentService } from 'src/app/agent/services/agent.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentPerformanceStatusHandlerComponent } from './agent-performance-status.handler';

@Component({
  selector: 'sym-agent-performance-status',
  templateUrl: './agent-performance-status.component.html',
  styleUrls: ['./agent-performance-status.component.scss'],
})
export class AgentPerformanceStatusComponent extends AgentPerformanceStatusHandlerComponent implements OnInit {
  public dateTimeRange1: Date[];
  @ViewChild('dateTimeRange') dateTimeRange: any;
  @ViewChild('frequncy') frequncy: ElementRef;
  minDate: Date;
  maxDate: Date;
  frequency: string;
  data: Date;
  currFreqModel: any;
  modelSave: boolean = false;
  modalSaveCheck: boolean = false;
  model1: boolean = false;
  model2: boolean = false;
  model3: boolean = false;
  inlineChartEvent: string = 'M';
  FromDate;
  ToDate;

  constructor(agentService: AgentService, public settingService: SettingService, public router: Router) {
    super(agentService, settingService, router);
  }
}
